import { Box, Typography } from "@mui/material";

export default function Heading({ _title, align = "center" }) {
  return (
    <Box
      textAlign="center"
      mb={4}
      mb={4}
      display="flex"
      justifyContent={
        align === "right"
          ? "flex-end"
          : align === "left"
            ? "flex-start"
            : "center"
      }
    >
      <Typography
        variant="h5"
        fontWeight={600}
        sx={{
          position: "relative",
          display: "inline-block",
          p: 1,
          color: "#222",
          letterSpacing: 1,
        }}
      >
        {_title}

        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "70%",
            height: "4px",
            borderRadius: "10px",
            background:
              "linear-gradient(90deg, #006b3f 0%, #00995c 50%, #4dd18f 100%)",
          }}
        />
      </Typography>
    </Box>
  );
}
